import CarouselRepository from "../CarouselRepository"

export default class FeatureCarousel extends CarouselRepository {
    static schemaId = "feature_carouselDetailed"

    constructor() {
        super(FeatureCarousel.schemaId)
    }
}
